import { getState } from './App';
import { getIntl } from './IntlInstance';

export const getCustomFieldTypeLabel = (customField) => {
  const intl = getIntl();

  if (customField.type === 'text') {
    return intl.formatMessage({ defaultMessage: 'One line text' });
  }
  if (customField.type === 'textarea') {
    return intl.formatMessage({ defaultMessage: 'Long text' });
  }
  if (customField.type === 'url') {
    return intl.formatMessage({ defaultMessage: 'Link' });
  }
  return '';
};

export const hasTaxonomyRoleSettingAllowed = (taxonomy, setting) => {
  const { profile } = getState().Auth;

  if (!profile || !profile.role) return true;

  const rolePermission = taxonomy.roles.find(r => r.id === profile.role.id);

  if (!rolePermission) return true;

  return Boolean(rolePermission[setting]);
};

export const getTaxonomyRoleSetting = (taxonomy, setting) => {
  const { profile } = getState().Auth;

  if (!profile || !profile.role) return null;

  const rolePermission = taxonomy.roles.find(r => r.id === profile.role.id);

  if (!rolePermission) return null;

  return Boolean(rolePermission[setting]);
};
